import {Box, Stack, useTheme} from "@mui/material";
import {PieChart} from "@mui/x-charts";
import React, {useMemo} from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";


export default function TransactionsByUser(props) {
   const theme = useTheme();

   const formatCurrency = (amount) => {
      // Handle potential null/undefined/non-numeric input gracefully
      const num = Number(amount);
      return `$${isNaN(num) ? '0.00' : num.toFixed(2)}`;
   };


   const pieChartData = useMemo(() => {
      const userMap = new Map();
      (props.accountUsers || []).forEach(user => {
         if (user && user.id && user.firstName) {
            userMap.set(user.id, user.firstName);
         }
      });

      const amountsByUser = {};

      (props.transactions || []).forEach(transaction => {
         if (transaction && typeof transaction.amount === 'number' && transaction.userId) {
            const userName = userMap.get(transaction.userId) || "Unknown";

            // Add the transaction amount to the user's total
            amountsByUser[userName] = (amountsByUser[userName] || 0) + transaction.amount;
         }
      });

      return Object.entries(amountsByUser)
         .map(([name, totalAmount], index) => ({
            id: index,
            value: totalAmount,
            label: `${name}: ${formatCurrency(totalAmount)}`
         }));

   }, [props.transactions, props.accountUsers]);

   return (
      <Stack direction="row" width="100%" textAlign="center" spacing={2}>
         <Box flexGrow={1}>
            <Paper
               elevation={3}
               sx={{
                  flexGrow: 1,
                  p: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1.5,
                  alignItems: 'center'
               }}
            >
               <Typography>Transactions By User</Typography>
               <PieChart
                  series={[
                     {
                        data: pieChartData,
                        innerRadius: 30,
                        outerRadius: 60,
                        highlightScope: { faded: 'global', highlighted: 'item' },
                        faded: { innerRadius: 20, additionalRadius: -5, color: 'gray' },
                        cx: 100
                     },
                  ]}
                  width={200}
                  height={120}
                  slotProps={{
                     legend: {
                        hidden: true,
                     },
                  }}
               />

            </Paper>
         </Box>
      </Stack>

   );
}